import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Drawer, List, Box } from '@material-ui/core'
import { SidebarItem } from '../../types'
import { mutualTheme } from '~/utils/theme'
import { SidebarExpandedButton } from './components'
import { transparentize, rgba } from 'polished'
import { MutualLogoWhite } from '~/assets/icons'

const useStyles = makeStyles({
  logoContainer: {
    height: mutualTheme.topbar.height
  },
  drawer: {
    backgroundColor: mutualTheme.sidebar.backgroundColor,
    width: mutualTheme.sidebar.expandedWidth
  },
  subtitle: {
    letterSpacing: 2,
    color: transparentize(0.65, mutualTheme.palette.common.white),
    paddingLeft: mutualTheme.spacing(2),
    paddingBottom: 0,
    fontSize: 'medium'
  },
  versionContainer: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'flex-end'
  },
  versionText: {
    backgroundColor: rgba(0, 0, 0, 0.15),
    margin: mutualTheme.spacing(2),
    padding: mutualTheme.spacing(1),
    color: mutualTheme.palette.common.white,
    borderRadius: mutualTheme.shape.borderRadius,
    width: '100%'
  }
})

export type SidebarExpanded = {
  isOpen: boolean,
  onClose: () => void,
  items: SidebarItem[]
}

export const SidebarExpanded: React.FC<SidebarExpanded> = (props) => {
  const classes = useStyles()
  const { isOpen, onClose, items } = props

  const itemsToRender = useMemo(() => {
    return items.map((item, index) => (
      <SidebarExpandedButton onClose={onClose} key={index} to={item.path} startIcon={item.icon} onClick={item.onClick}>
        {item.label}
      </SidebarExpandedButton>
    ))
  }, [items, onClose])

  return (
    <Drawer anchor='left' open={isOpen} onClose={onClose} classes={{ paper: classes.drawer }}>
      <Box style={{ display: 'inline-flex', justifyContent: 'left', alignItems: 'center', marginLeft: mutualTheme.spacing(3) }} className={classes.logoContainer}>
        <MutualLogoWhite />
      </Box>
      <List>
        {itemsToRender}
      </List>
    </Drawer>
  )
}
